const background = '#0b2933 !important';
const color = 'white !important';

const verticalCenter = {
  display: 'flex',
  alignItems: 'center',
};

export default {
  layout: {
    minHeight: '100vh',
    background: '#fff !important',
  },
  content: {
    margin: '0px 10px 10px 10px',
  },
  contentContainer: {
    background: '#fff',
    minHeight: '100%',
    overflow: 'auto',
  },
  header: {
    background,
    color,
    ...verticalCenter,
    padding: '0px !important',
  },
  sidebar: {
    background,
    color,
    height: '100%',
  },
  drawer: {
    height: '100%',
    '& div.ant-drawer-body': {
      color,
      background,
      padding: 0,
    },
    '& div.ant-drawer-wrapper-body': {
      color,
      background,
    },
    '& div.ant-drawer-content-wrapper': {
      width: '200px !important',
    },
  },
  '@media (min-width: 768px)': {
    drawer: {
      display: 'none',
    },
    collapseDrawerIcon: {
      display: 'none',
    },
  },
  '@media (max-width: 767px)': {
    sidebar: {
      display: 'none',
    },
    collapseIcon: {
      display: 'none',
    },
  },
  logo: {
    height: '50px',
    color,
    marginTop: '15px',
    transition: 'all 0.3s',
  },
  logoCollapsed: {
    height: '32px',
    color,
    marginTop: '15px',
    transition: 'all 0.3s',
  },
  logoCenterDiv: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  collapseIcon: {
    fontSize: '18px',
    marginLeft: '20px',
    cursor: 'pointer',
    outline: 'none!important',
  },
  collapseDrawerIcon: {
    fontSize: '18px',
    marginLeft: '20px',
    cursor: 'pointer',
    outline: 'none!important',
  },
  icon: {
    fontSize: '19px !important',
  },
  menu: {
    background,
    '& ul': {
      background,
    },
  },
  navBarMenu: {
    minWidth: '200px',
    '& span.anticon': {
      marginRight: '8px',
    },
  },
  action: {
    display: 'flex',
    float: 'right',
    marginLeft: 'auto',
    overflow: 'hidden',
    alignItems: 'center',
    height: '100%',
    padding: '0 12px',
    cursor: 'pointer',
    transition: 'all 0.3s',
    '> span': {
      verticalAlign: 'middle',
    },
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.025)',
    },
    '&:global(.opened)': {
      background: 'rgba(0, 0, 0, 0.025)',
    },
  },
  avatar: {
    margin: '~calc((@{layout-header-height} - 24px) / 2',
    marginRight: '8px',
    color: 'rgb(29, 54, 75)',
    verticalAlign: 'top',
    background: 'rgba(255, 255, 255, 0.85)',
  },
};
